import React from 'react'
import { Link } from 'react-router-dom';
const MobileMainContent = () => {
    const JavascriptVoid = (event) => {
        event.preventDefault();
    };
    return (
        <>
            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Mobile App Development
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 services-details mb-2">
                            <div className="ml-about-content">
                                {/* <h2>Mobile App Development</h2> */}
                                <h1>Leading Mobile App Development Company in Noida</h1>
                                <div className="bar" />
                                <p>
                                    Developing mobile apps is an engineering challenge distinct from desktop software development. The interface, storage footprint, and data access must all be tailored to the mobile device. Alobha Technologies, <b>Best Mobile App Development Company in Noida</b>, India, has
                                    created hundreds of custom mobile applications for our clients. Our
                                    mobile app development service extends to all major mobile
                                    platforms, including iPhone, iPad and Android.
                                </p>
                                <p>
                                    "We make it our job to understand your users because our success is
                                    tied to yours. We work with you to create a Mobile Application your
                                    users love."
                                </p>
                            </div>
                        </div>
                        <div className='container'>
                            <div className="row align-items-center mb-3 mt-3">
                                <div className="col-lg-6 col-md-6 services-details">
                                    <div className="services-details-desc">
                                        <div className="services-details-accordion">
                                            <h3>Our Mobile App Portfolio includes:</h3>
                                            <ul className="accordion">
                                                <li className="accordion-item">
                                                    <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                        Native apps on iOS, Android and Windows.
                                                    </Link>
                                                    {/* <p class="accordion-content show">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                                </li>
                                                <li className="accordion-item">
                                                    <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                        Cross-Platform Mobile Applications.
                                                    </Link>
                                                    {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                                </li>
                                                <li className="accordion-item">
                                                    <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                        Mobile Websites.
                                                    </Link>
                                                    {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                                </li>
                                                <li className="accordion-item">
                                                    <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                        We develop Mobile Applications across domains.
                                                    </Link>
                                                    {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 align-left services-details-accordion">
                                    <h5 className="mb-2 mt-3">Why Do You Choose Us?</h5>
                                    <p className="mt-2">We understand your problems as our own:</p>
                                    <p>Apply good Design Practice: from Persona Development, to
                                        Information Architecture, User Experience, Mood Boards, and
                                        Mock-ups.
                                    </p>
                                    <p>Follow Development Best-Practices: See our Process.</p>
                                    <p>Apply Rigorous Testing. See our Testing Services.</p>
                                    <p>Use the best Resources on your Project: Read About Us and the
                                        Team.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                <h2>Mobile App Development Services We Offer:</h2>
                                <div className="bar" />
                                <h3>
                                    <b>Best iOS App Development Company</b>
                                </h3>
                                <p>
                                    As we know, iOS platform is ruling in the global market as it’s
                                    always a first choice for mobile users. We have proven excellence in
                                    developing rich feature and instinctive iPhone mobile applications
                                    by embracing latest mobile trends and iOS technologies. We design
                                    engaging, interactive UI (User Interface) controls, and scalable iOS
                                    applications to deliver absolute user experience to target audience.
                                    We have developed iPhone applications for diverse industries, from
                                    gaming to entertaining to education to social networking to
                                    healthcare. We are creators and offer custom iPhone application
                                    development services that gives to your business jaw-dropping and
                                    unique solutions. Our multi-faceted approach allows us, how to
                                    develop iOS mobile application during initial phase zero to a
                                    successful launch of your application on Apple’s app store.
                                </p>
                                <p>
                                    Here at, Alobha Technologies, a leading <b>iOS app development company</b>, based in India, we provide <b>iPhone app development services</b> that provide a competitive edge to our client’s businesses.
                                </p>
                                <p>
                                    Our expert developers take your idea right from the inception to
                                    successful launch. Being a best iOS app development company, our
                                    methodologies are process-oriented and technologically advanced that
                                    help us to deliver efficient and best-in-class products and
                                    services.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/4.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/3.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                <h2>Best Android App Development Company</h2>
                                <div className="bar" />
                                <p>
                                    We not only develop websites; we try to build online image of your
                                    company in front world. Android a fastest growing operating system
                                    of smartphone devices has been popular with its each update. Its
                                    versatile, user friendly applications flexibility has made it more
                                    favorite. As an Android App development company, we have very high
                                    standards of quality. How do we live up to such high standards?
                                    Alobha Technologies offer comprehensive end-to-end services: our
                                    clients can watch their apps change from vague ideas to amazing,
                                    well-received completed products. Here, we’ve listed key processes
                                    in making sure that your app is successful. we are confident in and
                                    proud of the knowledge and talents of our Developers and designers,
                                    our customer’s opinion means a lot to us.
                                </p>
                                <div className="services-details-accordion">
                                    {/* <ul className="accordion">
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Which material types can you work with?
                                            </Link>
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Is Smart Lock required for instant apps?
                                            </Link>
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Can I have multiple activities in a single feature?
                                            </Link>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <h5 className="text-center mt-5 font-italic">For us, </h5>
                <h6 className="text-center font-italic mb-4">
                    "a great app is the one that is liked by our client’s target audiences, not
                    only the client."
                </h6> */}
            </section>

        </>
    )
}

export default MobileMainContent